import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { saveCustomer } from "../../actions/CustomerActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import { saveDriver } from '../../../src/actions/DriverActions';
import { getAllPermissions, getPermissionsByUserId, savePermissions } from "../../actions/UserActions";
import { useEffect } from "react";
import Mobilemenu from "../../layouts/mobile-menu";

function Permissions() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [permissions, setPermissions] = useState([]);
    const [permissionByIdSelected, setPermissionByIdSelected] = useState('true');
    const [permissionsDataState, setPermissionsDataState] = useState([]);

    useEffect(() => {
        dispatch(getAllPermissions());
        dispatch(getPermissionsByUserId(params.user_id));
    }, [])

    const permissionsData = useSelector(state => state?.users?.permissions);
    const permissionsById = useSelector(state => state?.users?.permissionsById);
    const loading = useSelector(state => state?.loading?.loading);

    useEffect(() => {
        setPermissionsDataState(permissionsData);
    }, [permissionsData])

    useEffect(() => {
        setPermissions(permissionsById && permissionsById.length > 0 && permissionsById);
    }, [permissionsById]);

    const handleChangePemissions = (e) => {
        const permissionIdToRemove = parseInt(e.target.value, 10);

        if (permissions && permissions.includes(permissionIdToRemove)) {
            let permissionsVar = permissions;
            permissionsVar = permissionsVar.filter(item => item != permissionIdToRemove);
            setPermissions(permissionsVar);
        } else {
            if (permissions && permissions.length > 0) {
                setPermissions([
                    ...permissions,
                    permissionIdToRemove
                ])
            } else {
                setPermissions([
                    permissionIdToRemove
                ])
            }
        }
    };

    const save = () => {
        if (permissions.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Please Assign Permissions!'
            })
        }
        else {
            let data = {
                user_id: params.user_id,
                permissions: permissions,
            }
            dispatch(savePermissions(data, navigate));
            dispatch(getPermissionsByUserId(params.user_id));
        }
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div class="intro-y d-flex align-items-center mt-8">
                        <h2 class="fs-lg fw-medium me-auto">
                            Assign Permissions
                        </h2>
                    </div>
                    <div class="grid columns-12 gap-6 mt-5">
                        <div class="intro-y g-col-12 g-col-lg-12">
                            <div class="intro-y box p-5">
                                <div>
                                    <div class="row">
                                        {Object.entries(permissionsData).map(([group_by, allPermissions]) => (
                                            <div key={group_by} className="col-sm-4">
                                                <div style={{ textTransform: 'capitalize', margin: '20px 0 10px', padding: '8px 8px 8px 18px', background: '#2D3748', color: '#fff', fontSize: '14px', borderRadius: '10px', width: '90%' }}>
                                                    {group_by}
                                                </div>
                                                <div className="row">
                                                    {Array.isArray(allPermissions) && allPermissions.map(permission => (
                                                        <div key={permission.permission_id} className="col-md-3 col-sm-3">
                                                            <div className="d-flex align-items-center " style={{ paddingLeft: '10px' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`permission-${permission.permission_id}`}
                                                                    onChange={(e) => handleChangePemissions(e)}
                                                                    className="minimal the-permission icheck icheck-primary me-2"
                                                                    value={permission.permission_id}
                                                                    checked={permissions && permissions.length > 0 && permissions.includes(permission.permission_id) ? true : false}
                                                                />
                                                                <label className="pull-left text-capitalize" htmlFor={`permission-${permission.permission_id}`}>
                                                                    {permission.name.substring(permission.name.indexOf('_') + 1)}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                        <button onClick={() => navigate('/users')} className="btn btn-outline-secondary bg-white w-24 ms-2">Cancel</button>
                                        <button onClick={save} disabled={loading ? true : false} type="button" className="btn btn-primary w-24 ms-2">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Permissions;